import React from 'react';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import Contents from './Contents';
import { COGNITO } from '#/config/consts';

const cognitoAuthConfig: AuthProviderProps = {
  authority: COGNITO.authority,
  client_id: COGNITO.clientId,
  redirect_uri: COGNITO.returnUrl,
  response_type: COGNITO.responseType,
  scope: COGNITO.scope,
};

const CognitoAuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <AuthProvider {...cognitoAuthConfig}>
      <Contents>{children}</Contents>
    </AuthProvider>
  );
};

export default React.memo(CognitoAuthProvider);
